import { withInstall } from "../utils/index.mjs";
import _IndexBar from "./IndexBar.mjs";
const IndexBar = withInstall(_IndexBar);
var stdin_default = IndexBar;
export {
  IndexBar,
  stdin_default as default
};
